import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'formly-star-rating',
    template: `
    <div class="star-rating">
      <mat-icon
        *ngFor="let star of ratingArr; let i = index"
        [color]="to['color'] || 'accent'"
        (click)="onClick(i + 1)"
        [style.color]="'#FDC400'"
        class="star-icon"
      >
        {{showIcon(i)}}
      </mat-icon>
      
    </div>
  `,
    styles: [`
    .star-rating {
      display: inline-flex;
      flex-direction: row;
      align-items: flex-start;
    }
    
    mat-icon {
      cursor: pointer;
    }

    :host ::ng-deep .mat-icon {
      color: #FDC400 !important;
      margin: 0.5rem;
    }

    ::ng-deep .star-icon {
      font-size: 2.5rem;
      width: 2.5rem;
      height: 2.5rem;
    }

  `],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StarRatingType extends FieldType<FieldTypeConfig> implements OnInit {

    override get formControl(): FormControl {
        return this.field.formControl as FormControl;
    }

    ratingArr: number[] = [];

    constructor() {
        super();
    }

    ngOnInit() {
        const starCount = this.to['starCount'] || 5;
        this.ratingArr = Array(starCount).fill(0).map((_, i) => i);
    }

    onClick(rating: number) {
        this.formControl.setValue(rating);
    }

    showIcon(index: number) {
        const rating = this.formControl.value || 0;
        return rating >= index + 1 ? 'star' : 'star_border';
    }
}